/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AttachmentsControllerDownloadAllAttachments$Params {
  entity: 'ddt' | 'delivery' | 'order' | 'order_customer' | 'ticket';
  entity_media_type: number;
  ids: Array<number>;
}

export function attachmentsControllerDownloadAllAttachments(http: HttpClient, rootUrl: string, params: AttachmentsControllerDownloadAllAttachments$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, attachmentsControllerDownloadAllAttachments.PATH, 'get');
  if (params) {
    rb.path('entity', params.entity, {});
    rb.path('entity_media_type', params.entity_media_type, {});
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

attachmentsControllerDownloadAllAttachments.PATH = '/attachments/{entity}/{entity_media_type}/download-all';
